<template>
  <div
    class="tw:bg-white tw:border tw:border-gray-300 tw:rounded-xl tw:flex tw:p-4 tw:gap-4 tw:flex-col tw:md:flex-row tw:max-w-full"
  >
    <img :src="filtersIcon" alt="Filters" class="tw:self-start" />
    <div class="tw:flex tw:flex-col tw:gap-4">
      <div>
        <h1 class="tw:mb-1 tw:text-xl tw:font-bold">
          {{ $t('plus_tips_prop_details_header') }}
        </h1>
        <p v-html="$t('plus_tips_prop_details_subtext')" />
      </div>
      <div
        class="tw:w-full tw:max-w-full tw:flex tw:flex-nowrap tw:gap-x-6 tw:gap-y-4 tw:overflow-x-auto tw:lg:flex-wrap tw:lg:overflow-x-visible hide-scrollbar"
      >
        <div
          class="item tw:flex tw:items-center tw:gap-x-2 tw:flex-shrink-0"
          v-for="item in availablePopularFilters"
          :key="item.featureId"
        >
          <img :src="imageMapping[item?.featureId]" />
          <span class="tw:whitespace-nowrap">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="tw:md:self-center">
      <router-link
        @click="logEvents"
        :to="{ name: 'property-details-basic-information', query: { open_filters: 'true' } }"
        class="tw:font-bold tw:text-blue-700 tw:text-nowrap"
        >{{ $t('plus_prop_details_cta') }}</router-link
      >
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import { popularFiltersIds } from '@/constants/propertyDetailsPopularFilters'
import { useGetPopularFilters } from '@/components/propertyDetails/queries'

import appAnalytics from '@/utils/tracking'
import { selectedAccommodationId } from '@/layouts/queries'

const filtersIcon = new URL('/src/assets/img/studio-plus-insights/filters-icon.svg', import.meta.url)
const paw = new URL(`../../../assets/img/property-details/paw.svg`, import.meta.url)
const spa = new URL(`../../../assets/img/property-details/spa.svg`, import.meta.url)
const pool = new URL(`../../../assets/img/property-details/pool.svg`, import.meta.url)
const wifi = new URL(`../../../assets/img/property-details/wifi.svg`, import.meta.url)
const kitchen = new URL(`../../../assets/img/property-details/kitchen.svg`, import.meta.url)
const parking = new URL(`../../../assets/img/property-details/parking.svg`, import.meta.url)
const airConditioning = new URL(`../../../assets/img/property-details/snowflake.svg`, import.meta.url)

const imageMapping = {
  25: parking,
  30: paw,
  732: wifi,
  60: spa,
  658: pool,
  86: airConditioning,
  255: kitchen,
}

const { allPopularFilters, isPopularFiltersLoading } = useGetPopularFilters()

const availablePopularFilters = computed(() => {
  if (isPopularFiltersLoading.value || !allPopularFilters.value) return []

  return allPopularFilters.value?.filter(
    item => popularFiltersIds.includes(item.featureId) && item.featureId && imageMapping[item.featureId]
  )
})

const logEvents = () => {
  appAnalytics.track(appAnalytics.events.SP_PLUS_INSIGHTS_TIP_FILTER_CLICKED, {
    item_id: selectedAccommodationId.value,
  })
}
</script>
<style scoped>
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
